// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 393 ? "1b36b0c3" : chunkId) + "." + {"74":"c38313ffae9e6386","393":"f830aec3c2ad3718"}[chunkId] + ".js";
};